(function(){
  'use strict';
  var cfg=window.SiwakSmileShopify||{root:'/',cartUrl:'/cart',checkoutUrl:'/checkout'};
  var root=(cfg.root||'/').replace(/\/$/,'');
  function money(cents){return new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format((cents||0)/100);}
  var cartCurrency='EUR',lastCart=null;
  function dlPush(eventName,items,done){
    if(!items||!items.length){if(done)done();return;}
    var total=0;
    items.forEach(function(i){total+=(i.final_line_price!=null?i.final_line_price:(i.price||0)*(i.quantity||1));});
    var payload={event:eventName,ecommerce:{currency:cartCurrency,value:total/100,items:items.map(function(i){return{variant_id:i.variant_id||i.id,item_id:i.product_id,item_name:i.product_title||i.title,price:(i.price||0)/100,quantity:i.quantity||1};})}};
    if(done){payload.eventCallback=done;payload.eventTimeout=800;}
    (window.dataLayer=window.dataLayer||[]).push(payload);
  }
  function cartItems(){return lastCart&&lastCart.items?lastCart.items:[];}
  function goCheckout(){
    var url=cfg.checkoutUrl||'/checkout',sent=false;
    var nav=function(){if(sent)return;sent=true;location.href=url;};
    setTimeout(nav,900);
    dlPush('shopify_begin_checkout',cartItems(),nav);
  }
  function json(url,opts){return fetch(root+url,Object.assign({headers:{'Accept':'application/json','Content-Type':'application/json'}},opts||{})).then(function(r){if(!r.ok)return r.json().then(function(e){throw new Error(e.description||e.message||'Erreur Shopify');});return r.json();});}
  /* Tiroir de panier. Trois zones : une tete et un bandeau fixes, la liste qui
     defile, un pied fixe. Le pied porte ce qui fait avancer la commande :
     suggestions, seuil de port offert, sous-total, paiement. */
  /* Masterclass CRO 6.9 : livraison offerte dès 30 € en point relais, NanoBrosse offerte dès 49 €,
     une seule suggestion à la fois, jamais un produit déjà contenu dans le Kit. */
  var SC_SEUIL_PORT=3000,SC_SEUIL_CADEAU=4900,SC_DEUXIEME_KIT=2490,SC_DEUX_KITS=6282;
  /* Remise Shopify « Dentifrice : 2 tubes 26,90 € ». Le deuxieme tube revient
     donc a 12,00 €, et c'est le chemin le moins cher vers les 30 €. */
  var SC_DEUX_TUBES=2690;
  var SC_PROMOS=['Livraison offerte dès 30 € en point relais','60 jours pour essayer, vous gardez les produits','★ 4,8/5 sur Trustpilot · 51 avis · 10 000 clients'];
  /* Le point relais n'existe pas partout, et il n'est offert que la ou il
     coute moins que la limite de 4,90 € : France, Belgique, Luxembourg.
     Ailleurs on ne promet rien, on affiche le tarif du pays. Les trois zones
     sans relais du tout (Suisse, La Reunion, Guyane) laissent le paiement
     calculer. Tarifs cales sur la grille Shopify. */
  var SC_RELAIS={FR:290,BE:490,LU:490,NL:550,DE:660,ES:650,PT:650,PL:710,IT:730};
  var SC_PAYS_PORT_OFFERT=['FR','BE','LU'];
  /* Operation « un siwak offert », ouverte a tout le monde et non plus aux
     seuls inscrits. Les dates et les phrases viennent de window.SC_OPERATION,
     pose par snippets/offre-cadeau.liquid : c'est la seule source, pour que
     prolonger l'operation ne demande de toucher qu'un fichier. Le repli ci-
     dessous ne sert que si le snippet n'a pas ete rendu.
     L'annonce s'eteint d'elle-meme le lendemain de la fin : une promesse qui
     survit a son offre devient un mensonge. Le cadeau lui-meme, lui, continue
     d'etre ajoute tant que personne ne decide le contraire : mieux vaut etre
     genereux apres la date qu'avoir annonce ce qu'on ne donne plus. */
  var SC_OP_REPLI={debut:20261019,fin:20261031,
    longue:'Du 19 au 31 octobre : un siwak et son porte-siwak offerts à chaque commande',
    courte:'Un siwak offert à chaque commande, jusqu’au 31 octobre'};
  function scOperation(){return window.SC_OPERATION||SC_OP_REPLI;}
  /* Le bandeau est sur une seule ligne, sans defilement : mesure sur un ecran
     de 375 px, la phrase longue fait 458 px et se fait couper en silence. On
     garde donc deux versions, et les deux disent la date et « chaque
     commande », qui est ce qui change aujourd'hui. */
  function SC_OFFRE_CADEAU(){
    var o=scOperation();
    return (window.innerWidth>=700)?o.longue:o.courte;
  }
  function scOffreEnCours(){
    var o=scOperation(),d=new Date(),j=d.getFullYear()*10000+(d.getMonth()+1)*100+d.getDate();
    return j>=o.debut&&j<=o.fin;
  }
  function scPays(){return String((window.Shopify||{}).country||'FR').toUpperCase();}
  function scPrixRelais(){var p=SC_RELAIS[scPays()];return typeof p==='number'?p:null;}
  function scPortOffrable(){return SC_PAYS_PORT_OFFERT.indexOf(scPays())>=0;}
  function scPromos(){
    var l=SC_PROMOS.slice();
    if(scOffreEnCours())l.unshift(SC_OFFRE_CADEAU());
    if(!scPortOffrable()){
      var p=scPrixRelais();
      l[0]=p?'Point relais à '+money(p)+' · expédié de Nice':'Expédié de Nice sous 48 h ouvrées';
    }
    return l;
  }
  var SC_SUGGESTIONS=['pack-challenge-28-jours','dentifrice-au-siwak','nanobrosse-clean','kit-siwak-addict'];
  var H={kit:'pack-challenge-28-jours',dent:'dentifrice-au-siwak',addict:'kit-siwak-addict',nano:'nanobrosse-clean',bienvenue:'cadeau-de-bienvenue-1-baton-de-siwak-son-etui',appoint:'2-batons-de-siwak-1-porte-siwak'};
  /* Cadeaux ajoutes au panier des que leur seuil est atteint, dans cet ordre.
     `motif` reconnait la remise Shopify correspondante : sans elle le cadeau
     serait facture au client, donc on le retire plutot que de le laisser.
     `avecNano` dit si une NanoBrosse deja au panier compte dans le seuil :
     non pour la NanoBrosse offerte, sinon elle se paierait elle-meme. */
  var SC_CADEAUX=[
    /* Seuil a 1 centime : le cadeau part des qu'il y a un produit au panier,
       sans montant minimum. Il n'est pas un palier a franchir, c'est une
       avance offerte : le seul palier reste la livraison a 30 €. */
    {cle:'bienvenue',handle:H.bienvenue,seuil:1,avecNano:true,etiquette:'Un siwak et son porte-siwak, offerts avec votre commande',motif:/cadeau de bienvenue/i},
    {cle:'nano',handle:H.nano,seuil:SC_SEUIL_CADEAU,avecNano:false,etiquette:'NanoBrosse offerte dès 49 € d’achat',motif:/nanobrosse/i}
  ];
  var scCatalogue=null,scBusy=false,scCadeauKo=false,scCodeOuvert=false;
  /* Masterclass 6.9 : boutons de paiement accéléré (bloc rendu par Shopify, déplacé dans le panier),
     logos de paiement et lien « J'ai un code ». */
  /* v25 (11/10) : boutons de paiement express (Apple Pay, Google Pay, Shop Pay, PayPal) redessinés par Shopify
     avec le panier du moment (Section Rendering API, section cx-express), à l'ouverture du panier et à chaque
     changement. Avant, ils étaient rendus une seule fois au chargement de la page, souvent avec un panier vide
     (sans montant ni livraison) : au clic, Shopify renvoyait vers la page de paiement.
     Si un portefeuille ne peut pas payer ce panier (abonnement par exemple), Shopify ne le dessine pas. */
  var expressSig='',expressSeq=0;
  function expressSignature(cart){return cart.total_price+'|'+cart.requires_shipping+'|'+cart.items.map(function(i){return i.key+':'+i.quantity;}).join(',');}
  function rafraichirExpress(cart){
    var pied=overlay.querySelector('[data-sc-express]'),corps=overlay.querySelector('[data-sc-express-corps]');if(!pied||!corps)return;
    function vider(s){s.innerHTML='';s.hidden=true;s.classList.remove('is-loading');}
    if(!cart||!cart.items||!cart.items.length){expressSeq++;expressSig='';vider(pied);vider(corps);return;}
    var sig=expressSignature(cart);
    if(sig===expressSig)return;
    expressSig=sig;var n=++expressSeq;
    /* Avec un abonnement, Shopify ajoute sous les boutons un texte de consentement obligatoire (5 lignes) :
       les boutons vont alors dans la liste, après le total, pour laisser la place aux produits. */
    var abo=cart.items.some(estAbo),slot=abo?corps:pied;
    vider(abo?pied:corps);
    slot.hidden=false;slot.classList.add('is-loading');
    fetch(root+'/cart?sections=cx-express',{credentials:'same-origin'})
      .then(function(r){if(!r.ok)throw new Error('express '+r.status);return r.json();})
      .then(function(d){if(n!==expressSeq)return;slot.innerHTML=(d&&d['cx-express'])||'';slot.hidden=!slot.querySelector('shopify-accelerated-checkout-cart');})
      .catch(function(){if(n!==expressSeq)return;expressSig='';slot.innerHTML='';slot.hidden=true;})
      .then(function(){if(n===expressSeq)slot.classList.remove('is-loading');});
  }
  function logos(){var src=document.querySelector('[data-cx-logos-source]');return src&&src.innerHTML.trim()?'<div class="sc__logos">'+src.innerHTML+'</div>':'';}
  function scCode(cart){
    var codes=(cart.discount_codes||[]).map(function(c){return '<p class="sc__code-ok">Code '+escapeHtml(c.code)+(c.applicable?' appliqué':' non applicable à ce panier')+'</p>';}).join('');
    return '<div class="sc__code">'+codes+(scCodeOuvert
      ?'<form class="sc__code-form" data-sc-code><label class="sr-only" for="sc-code">Code promo</label><input id="sc-code" name="code" autocomplete="off" placeholder="Votre code"><button type="submit">Appliquer</button></form>'
      :'<button type="button" class="sc__code-lien" data-sc-code-ouvrir>J’ai un code</button>')+'</div>';
  }
  var overlay=document.createElement('div');
  overlay.className='sc';
  overlay.innerHTML='<div class="sc__panel" role="dialog" aria-modal="true" aria-label="Votre panier">'
    +'<header class="sc__head"><h2 class="sc__title">Panier</h2><button class="sc__close" type="button" aria-label="Fermer le panier">✕</button></header>'
    +'<div class="sc__promo" aria-live="off"><span></span></div>'
    +'<div class="sc__body"><div data-sc-liste></div><div class="sc__express sc__express--corps" data-sc-express-corps hidden></div><div data-sc-fin></div></div>'
    +'<footer class="sc__foot"><div data-sc-foot1></div><div class="sc__express" data-sc-express hidden></div></footer></div>';
  document.body.appendChild(overlay);

  /* Le bandeau orange fait defiler les preuves, comme une annonce d en-tete. */
  (function(){
    var cible=overlay.querySelector('.sc__promo'),texte=cible.querySelector('span'),i=0;
    var promos=scPromos();
    texte.textContent=promos[0];
    if(promos.length<2)return;
    setInterval(function(){
      if(!overlay.classList.contains('is-open'))return;
      cible.classList.add('is-fading');
      setTimeout(function(){i=(i+1)%promos.length;texte.textContent=promos[i];cible.classList.remove('is-fading');},350);
    },4200);
  })();

  /* v25 : overflow:hidden ne suffit pas sur iPhone : la page continuait de défiler sous le panier et la barre
     de Safari changeait la hauteur de l'écran. On fige la page à sa position, puis on la rend à la fermeture. */
  var scY=0,scVerrou=false;
  function verrouiller(){if(scVerrou)return;scVerrou=true;scY=window.pageYOffset||document.documentElement.scrollTop||0;var h=document.documentElement,b=document.body;h.style.overflow='hidden';b.style.position='fixed';b.style.top=(-scY)+'px';b.style.left='0';b.style.right='0';b.style.width='100%';}
  function deverrouiller(){if(!scVerrou)return;scVerrou=false;var h=document.documentElement,b=document.body,sb=h.style.scrollBehavior;h.style.overflow='';b.style.position='';b.style.top='';b.style.left='';b.style.right='';b.style.width='';h.style.scrollBehavior='auto';window.scrollTo(0,scY);h.style.scrollBehavior=sb;}
  function close(){overlay.classList.remove('is-open');deverrouiller();}
  function open(){overlay.classList.add('is-open');verrouiller();try{overlay.querySelector('.sc__close').focus({preventScroll:true});}catch(e){}dlPush('shopify_view_cart',cartItems());var lb=overlay.querySelector('.sc__body');if(lb)lb.scrollTop=0;if(lastCart)rafraichirExpress(lastCart);}
  overlay.addEventListener('click',function(e){if(e.target===overlay||e.target.closest('.sc__close'))close();});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  function escapeHtml(v){var d=document.createElement('div');d.textContent=v||'';return d.innerHTML;}
  function planSummary(item){
    if(!item.selling_plan_allocation)return '';
    /* v31 (13/10) : fonctionnement réel de l'app « SiwakSmile Abonnements » (page Guide et configuration,
       contrats vérifiés) : le lot choisi arrive au 1er envoi, puis 1 unité toutes les 6 semaines. */
    var q=item.quantity,s={'pack-challenge-28-jours':['Kit','Kits','1 Recharge (dentifrice, 4 bâtons, NanoBrosse) à 24,90 €','livraison offerte en point relais.'],'dentifrice-au-siwak':['tube','tubes','1 tube à 12,67 €','livraison offerte en point relais. Le sablier n’arrive qu’avec ce 1er envoi.'],'kit-siwak-addict':['pack','packs','5 bâtons à 17 €','livraison offerte en point relais. Les étuis n’arrivent qu’avec ce 1er envoi.'],'nanobrosse-clean':['brosse','brosses','1 brosse à 6,70 €','livraison en plus.'],'recharge-rituel':['Recharge','Recharges','1 Recharge à 24,90 €','livraison offerte en point relais.']}[item.handle];
    if(!s)return '<p>'+escapeHtml(item.selling_plan_allocation.selling_plan.name)+'</p>';
    return '<p>Abonnement · sans engagement</p><p>Aujourd’hui : '+q+' '+(q>1?s[1]:s[0])+'. Ensuite : '+s[2]+' toutes les 6 semaines, '+s[3]+'</p>';
  }


  /* Le cadeau de bienvenue est la contrepartie de l'e-mail : il n'apparait
     qu'aux inscrits. Klaviyo previent par l'evenement `klaviyoForms` au moment
     de l'inscription ; la marque reste en localStorage pour les visites
     suivantes, et le cookie `__kla_id` rattrape ceux qui etaient deja inscrits.
     C'est par appareil : rien d'autre n'est disponible cote client. */
  /* Dormant depuis le 19/10/2026 : le cadeau est ouvert a tout le monde, plus
     aucune entree de SC_CADEAUX ne porte `inscrit`. Le mecanisme reste la pour
     qu'un cadeau futur puisse de nouveau etre reserve aux inscrits : il suffit
     de remettre `inscrit:true` sur la ligne concernee. */
  var SC_CLE_INSCRIT='sc_inscrit_bienvenue';
  function scMarqueInscrit(){try{localStorage.setItem(SC_CLE_INSCRIT,'1');}catch(e){}}
  function scKlaviyoIdentifie(){
    try{
      var m=document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if(!m)return false;
      var d=JSON.parse(atob(decodeURIComponent(m[1])));
      if(d&&d.$email){scMarqueInscrit();return true;}
    }catch(e){}
    return false;
  }
  function scEstInscrit(){
    try{if(localStorage.getItem(SC_CLE_INSCRIT)==='1')return true;}catch(e){}
    return scKlaviyoIdentifie();
  }
  window.addEventListener('klaviyoForms',function(e){
    if(!e||!e.detail||e.detail.type!=='submit')return;
    scMarqueInscrit();
    loadCart(false);
  });

  function estCadeau(i){return !!(i.properties&&i.properties._cadeau);}
  function estAbo(i){return !!i.selling_plan_allocation;}
  function produit(h){return (scCatalogue||[]).filter(function(p){return p.handle===h;})[0];}
  function quantite(cart,h){return cart.items.reduce(function(t,i){return t+(i.handle===h&&!estCadeau(i)?i.quantity:0);},0);}
  function portAbo(cart){return toutAbo(cart)&&cart.items.some(function(i){return estAbo(i)&&!estCadeau(i)&&i.handle!==H.nano;});}
  function toutAbo(cart){var l=cart.items.filter(function(i){return !estCadeau(i);});return l.length>0&&l.every(estAbo);}
  /* Base de la NanoBrosse offerte : achats uniques, hors NanoBrosse et hors cadeau. */
  /* Un cadeau est valide si sa ligne tombe a zero, ou si une remise de commande portant son nom la compense. */
  /* Les paniers deja ouverts portent `_cadeau:'1'` : c'etait la NanoBrosse. */
  function cadeauDe(i){var c=i.properties&&i.properties._cadeau;return SC_CADEAUX.filter(function(x){return x.cle===c;})[0]||SC_CADEAUX[1];}
  function cadeauOk(c,g){var d=cadeauDe(g);return !g.final_line_price||(c.cart_level_discount_applications||[]).some(function(a){return d.motif.test(a.title||'');});}
  function baseCadeau(cart,avecNano){return cart.items.reduce(function(t,i){return t+(estCadeau(i)||estAbo(i)||(!avecNano&&i.handle===H.nano)?0:i.final_line_price);},0);}
  function scPrixLigne(i){
    if(!i.final_line_price||estCadeau(i))return '<span>Offert</span>';
    var s=money(i.final_line_price);
    if(i.original_line_price>i.final_line_price&&!estAbo(i))s+='<s>'+money(i.original_line_price)+'</s>';
    return s;
  }

  /* 08/10 (Xebec) : sur un Kit seul en achat unique, proposer l'abonnement. v31 : le mot « Rituel » devient « abonnement ». */
  function scRituel(i){
    if(i.handle!==H.kit||estAbo(i)||estCadeau(i)||i.quantity!==1)return '';
    var k=produit(H.kit);if(!k||!k.plan||!k.planPrix||!k.planPrix[0])return '';
    var p1=k.planPrix[0],p2=k.planPrix[1]||p1;
    return '<div class="sc__rituel"><p class="sc__rituel-titre">Payez moins avec l’abonnement</p><p>Les taches reviennent avec le café. <strong>'+money(p1)+'</strong> aujourd’hui au lieu de '+money(i.final_line_price)+', puis 1 Recharge à '+money(p2)+' toutes les 6 semaines, livraison offerte en point relais. Sans engagement.</p>'
      +'<button type="button" data-sc-rituel="'+escapeHtml(i.key)+'">Passer à l’abonnement</button></div>';
  }

  /* v25 : une ligne par produit. Shopify coupe la ligne quand une remise ne porte que sur une partie de la
     quantité (2 Kits = 1 Kit à 34,90 € + 1 Kit à 24,90 €). On additionne et on affiche la remise appliquée.
     Le stepper agit sur la dernière ligne du groupe, « Retirer » met toutes les lignes du groupe à 0. */
  function scGroupes(cart){
    var g=[],idx={};
    cart.items.forEach(function(i){
      var plan=i.selling_plan_allocation?i.selling_plan_allocation.selling_plan.id:'';
      var k=estCadeau(i)?'cadeau|'+i.key:i.variant_id+'|'+plan+'|'+JSON.stringify(i.properties||{});
      if(idx[k]==null){idx[k]=g.length;g.push([]);}
      g[idx[k]].push(i);
    });
    return g.map(function(l){
      var o=Object.assign({},l[0]);o.quantity=0;o.final_line_price=0;o.original_line_price=0;o.cles=[];o.remises=[];o.derniere=l[l.length-1];
      l.forEach(function(i){o.quantity+=i.quantity;o.final_line_price+=i.final_line_price;o.original_line_price+=i.original_line_price;o.cles.push(i.key);
        (i.line_level_discount_allocations||[]).forEach(function(d){var t=d.discount_application&&d.discount_application.title;if(d.amount>0&&t&&o.remises.indexOf(t)<0)o.remises.push(t);});});
      return o;
    });
  }
  function scRemise(t){return /deuxi[eè]me kit/i.test(t)?'2e Kit à '+money(SC_DEUXIEME_KIT)+' appliqué':t;}
  function scLigne(i){
    var d=i.derniere||i;
    return '<article class="sc__line">'
      +'<img src="'+escapeHtml(i.image||'')+'" alt="" width="90" height="90" loading="eager">'
      +'<div>'
        +'<a class="sc__name" href="'+escapeHtml(i.url||'#')+'">'+escapeHtml(i.product_title)+'</a>'
        +(estCadeau(i)?'<div class="sc__free">'+escapeHtml(cadeauDe(i).etiquette)+'</div>':(!i.final_line_price?'<div class="sc__free">Offert</div>':''))
        +(i.variant_title&&i.variant_title!=='Default Title'&&i.handle!==H.dent?'<div class="sc__plan">'+escapeHtml(i.variant_title)+'</div>':'')
        +planSummary(i)
        +(i.remises&&i.remises.length&&!estCadeau(i)?'<div class="sc__remise">'+i.remises.map(function(t){return '✓ '+escapeHtml(scRemise(t));}).join('<br>')+'</div>':'')
        +'<div class="sc__row">'
          +(estCadeau(i)?'<span class="sc__qte-cadeau">Quantité : 1</span>':'<span class="sc__step">'
            +'<button type="button" data-key="'+escapeHtml(d.key)+'" data-qty="'+(d.quantity-1)+'" aria-label="Retirer une unité"'+(i.quantity<2?' disabled':'')+'>−</button>'
            +'<span aria-live="polite">'+i.quantity+'</span>'
            +'<button type="button" data-key="'+escapeHtml(d.key)+'" data-qty="'+(d.quantity+1)+'" aria-label="Ajouter une unité">+</button>'
          +'</span>')
          +'<span class="sc__price">'+scPrixLigne(i)+'</span>'
        +'</div>'
        +(estCadeau(i)?'':'<button class="sc__del sc__del--txt" type="button" data-sc-retirer="'+escapeHtml((i.cles||[i.key]).join(','))+'" aria-label="Retirer '+escapeHtml(i.product_title)+' du panier">Retirer</button>')
      +'</div>'
    +'</article>';
  }

  function scProgression(cart){
    if(portAbo(cart))return '<div class="sc__prog"><p class="sc__prog-msg">Livraison offerte en point relais, à chaque envoi ✓</p></div>';
    /* Le cadeau ne figure pas ici, volontairement : un cadeau qui recompense
       un palier arrete l'effort une fois le palier atteint. Il est deja dans
       le panier ; la barre ne montre que ce qui reste a atteindre. */
    var t=cart.total_price,base=baseCadeau(cart),offrable=scPortOffrable();
    var port=offrable&&t>=SC_SEUIL_PORT,nano=base>=SC_SEUIL_CADEAU&&!scCadeauKo;
    var msg;
    if(offrable&&!port){
      msg='Plus que '+money(SC_SEUIL_PORT-t)+' pour la livraison offerte en point relais';
    }else if(base<SC_SEUIL_CADEAU){
      msg=(port?'Livraison offerte ✓ · ':'')+'Plus que '+money(SC_SEUIL_CADEAU-base)+' pour recevoir la NanoBrosse en cadeau';
    }else{
      msg=[port?'✓ Livraison offerte':'',nano?'✓ NanoBrosse offerte':''].filter(Boolean).join(' · ')
        ||'Expédié de Nice sous 48 h ouvrées';
    }
    var part=Math.max(0,Math.min(1,base/SC_SEUIL_CADEAU)),p1=(SC_SEUIL_PORT/SC_SEUIL_CADEAU*100).toFixed(1);
    return '<div class="sc__prog">'
      +'<p class="sc__prog-msg">'+msg+'</p>'
      +'<div class="sc__prog-track"><span class="sc__prog-fill" style="width:'+(part*100).toFixed(1)+'%"></span>'
      +(offrable?'<span class="sc__prog-dot'+(port?'':' is-off')+'" style="left:'+p1+'%"></span>':'')
      +'<span class="sc__prog-dot'+(base>=SC_SEUIL_CADEAU?'':' is-off')+'" style="left:100%"></span></div>'
      +'<div class="sc__prog-labels sc__prog-labels--paliers">'+(offrable?'<span style="left:'+p1+'%">Livraison offerte</span>':'')+'<span style="left:100%">NanoBrosse offerte</span></div>'
    +'</div>';
  }

  function carteSugg(titre,nom,p,prix,phare){
    if(!p)return '';
    return '<div class="sc__gift'+(phare?' sc__gift--kit':'')+'">'
      +'<div class="sc__gift-head"><span class="sc__gift-title">'+titre+'</span></div>'
      +'<div class="sc__gift-track"><div class="sc__sugg"><img src="'+escapeHtml(p.image||'')+'" alt="" width="56" height="56" loading="eager">'
      +'<div><div class="sc__sugg-name">'+nom+'</div>'
      +'<div class="sc__sugg-price">'+prix+'</div>'
      +'<button type="button" data-sc-ajout="'+p.variante+'">Ajouter</button></div></div></div></div>';
  }
  function scSuggestions(cart){
    if(!scCatalogue||!cart.items.length||toutAbo(cart))return '';
    var t=cart.total_price,kit=quantite(cart,H.kit),dent=quantite(cart,H.dent),addict=quantite(cart,H.addict),nano=quantite(cart,H.nano);
    if(kit>0){
      var k=produit(H.kit);
      var lk=cart.items.filter(function(i){return i.handle===H.kit&&!estCadeau(i);})[0];
      var rt=lk&&kit===1?scRituel(lk):'';
      /* 08/10 (Xebec) : toujours une proposition pour faire monter le panier, en plus du Rituel.
         Sous 49 € : le produit qui débloque la NanoBrosse offerte (cohérent avec la barre).
         Au-dessus : le deuxième Kit pour un proche. */
      /* v25 (11/10, Xebec) : un seul Kit en achat unique → le 2e Kit à 24,90 € d'abord (il débloque aussi la
         NanoBrosse offerte). Sinon, sous 49 € : le produit qui débloque la NanoBrosse. */
      var ajout='',bc=baseCadeau(cart);
      var kitAbo=cart.items.some(function(i){return i.handle===H.kit&&estAbo(i);});
      /* v31 (13/10) : lots de Kits en achat unique, 2 Kits -10 % (62,82 €), 3 Kits -15 % (89 €). */
      if(kit===1&&!kitAbo&&k)ajout=carteSugg('Pour un proche : 2 Kits à -10 %','2 Kits : '+money(SC_DEUX_KITS)+' au lieu de '+money(2*k.prix)+', NanoBrosse offerte',k,'<strong>+ '+money(SC_DEUX_KITS-k.prix)+'</strong> <s>'+money(k.prix)+'</s>',true);
      if(!ajout&&bc<SC_SEUIL_CADEAU){
        var pc=dent===0?produit(H.dent):(addict===0?produit(H.addict):null);
        if(pc)ajout=carteSugg('Ajoutez '+money(SC_SEUIL_CADEAU-bc)+' et la NanoBrosse est offerte',pc.handle===H.dent?'Dentifrice au siwak':'Siwak Addict · 5 bâtons + 2 étuis',pc,money(pc.prix));
      }
      return ajout+(rt?'<div class="sc__rituel-zone">'+rt+'</div>':'');
    }
    if(scPortOffrable()&&t<SC_SEUIL_PORT){
      var manque=SC_SEUIL_PORT-t,relais=scPrixRelais()||0;
      /* Une proposition se juge a ce qu'elle fait gagner, pas a ce qui manque.
         Quand le produit propose fait franchir les 30 €, on l'annonce et on
         dit ce qu'il coute vraiment une fois le port recupere. Sinon on
         annonce honnetement la marche suivante. */
      /* Gabarit des cartes, mesure sur un ecran de 375 px :
           titre  253 px, sans troncature, il peut passer a la ligne
           nom    161 px borne a DEUX lignes, soit 44 caracteres environ
           prix   161 px, une seule ligne
         Tout ce qui depasse le nom est coupe sans prevenir, et c'est
         toujours la fin de la phrase, donc l'argument. L'argument va dans
         le titre, le nom ne porte que le produit et son benefice. */
      var tete=function(prix){
        return (t+prix>=SC_SEUIL_PORT)
          ?'Ajoutez-le et la livraison passe à 0 €'
          :'Plus que '+money(manque)+' pour la livraison offerte';
      };
      /* La derniere marche : l'appoint a 5 € comble les paniers entre 25 et
         30 €. On annonce ce qu'il coute vraiment, port recupere deduit. */
      if(manque<=500&&quantite(cart,H.appoint)===0){
        var ap=produit(H.appoint);
        if(ap)return carteSugg('Il ne vous coûte que '+money(ap.prix-relais)+', et la livraison passe à 0 €','2 bâtons de siwak + 1 porte-siwak',ap,money(ap.prix));
      }
      /* Un seul tube, le panier le plus frequent du site : vingt commandes sur
         cent vingt. Le deuxieme tube coute 12,00 € au lieu de 14,90 €, c'est
         la marche la plus basse vers le seuil, et c'est le produit qu'il a
         deja choisi. On vise l'acceptation, pas la marge : une proposition
         refusee ne vaut rien, et c'est le franchissement du seuil qui cree la
         marge, pas le prix de ce qu'on ajoute. */
      var pd=produit(H.dent);
      /* La remise « 2 tubes » ne vaut que pour l'achat unique : si le tube du
         panier est un abonnement, la carte annoncerait un prix qui n'arrivera
         pas au paiement. */
      var ligneDent=cart.items.filter(function(i){return i.handle===H.dent&&!estCadeau(i)&&!estAbo(i);})[0];
      if(dent===1&&pd&&ligneDent){
        var second=SC_DEUX_TUBES-pd.prix,apres=t+second;
        /* Un tube dure six semaines : le deuxieme se vend en duree, pas en
           arithmetique de panier. Le reste a parcourir est deja dans la barre
           de progression juste au-dessus. */
        return carteSugg(
          apres>=SC_SEUIL_PORT
            ?'Le 2e tube à '+money(second)+', et la livraison passe à 0 €'
            :'Le 2e tube à '+money(second)+' au lieu de '+money(pd.prix),
          '12 semaines de brossage au lieu de 6',
          pd,'<strong>+ '+money(second)+'</strong> <s>'+money(pd.prix)+'</s>');
      }
      if(dent>0&&addict===0){
        var ligne=cart.items.filter(function(i){return i.handle===H.dent;})[0];
        var pn=produit(H.nano);
        if(ligne&&/2/.test(ligne.variant_title||'')&&nano===0&&pn)return carteSugg(tete(pn.prix),'NanoBrosse Clean+, extra-souple',pn,money(pn.prix));
        var pa=produit(H.addict);
        if(pa)return carteSugg(tete(pa.prix),'5 bâtons + 2 étuis, pour la poche',pa,money(pa.prix));
      }
      if((addict>0||nano>0)&&dent===0&&pd)return carteSugg(tete(pd.prix),'Dentifrice au siwak, 6 semaines',pd,money(pd.prix));
      return '';
    }
    if(baseCadeau(cart)<SC_SEUIL_CADEAU){
      var p=dent===0?produit(H.dent):(addict===0?produit(H.addict):null);
      if(!p)return '';
      return carteSugg('Ajoutez '+money(SC_SEUIL_CADEAU-baseCadeau(cart))+' et la NanoBrosse est offerte',p.handle===H.dent?'Dentifrice au siwak':'Siwak Addict · 5 bâtons + 2 étuis',p,money(p.prix));
    }
    return '';
  }
  /* NanoBrosse offerte dès 49 € : ajoutée seule au-dessus du seuil, retirée en dessous.
     Si la remise Shopify n'est pas active (la ligne ne passe pas à 0 €), on la retire et on n'insiste pas. */
  /* Un seul geste par passe ne suffit pas : avec deux cadeaux, le second
     n'arrivait qu'au chargement de page suivant, alors que sa remise, elle,
     s'applique des le premier. Entre les deux, le client voyait 7,90 € de
     moins sans la NanoBrosse dans son panier. On relit donc le panier apres
     chaque geste et on recommence, jusqu'a ce qu'il n'y ait plus rien a faire. */
  function scCadeau(cart,reste){
    if(scBusy||scCadeauKo||!scCatalogue)return Promise.resolve(cart);
    if(typeof reste!=='number')reste=4;
    function encore(p){
      if(reste<=0)return p;
      return p.then(function(){return json('/cart.js');}).then(function(x){return scCadeau(x,reste-1);});
    }
    var lignes=cart.items.filter(estCadeau);
    var ko=lignes.filter(function(g){return !cadeauOk(cart,g);})[0];
    if(ko){scCadeauKo=true;return scRetire(ko);}
    var doublon=lignes.filter(function(g){return g.quantity>1;})[0];
    if(doublon){scBusy=true;return encore(json('/cart/change.js',{method:'POST',body:JSON.stringify({id:doublon.key,quantity:1})}).finally(function(){scBusy=false;}));}
    var abo=toutAbo(cart);
    for(var n=0;n<SC_CADEAUX.length;n++){
      var c=SC_CADEAUX[n],p=produit(c.handle);
      if(!p)continue;
      var ligne=lignes.filter(function(g){return g.handle===c.handle;})[0];
      var payee=cart.items.some(function(i){return i.handle===c.handle&&!estCadeau(i)&&!estAbo(i);});
      var acquis=!abo&&!payee&&(!c.inscrit||scEstInscrit())&&baseCadeau(cart,c.avecNano)>=c.seuil;
      if(acquis&&!ligne)return encore(scAjouteCadeau(p,c));
      if(!acquis&&ligne)return encore(scRetire(ligne));
    }
    return Promise.resolve(cart);
  }

  function scRetire(l){scBusy=true;return json('/cart/change.js',{method:'POST',body:JSON.stringify({id:l.key,quantity:0})}).finally(function(){scBusy=false;});}

  /* On relit le panier apres l'ajout : si la remise n'a pas pris, le cadeau
     serait facture au client, donc on le retire aussitot et on n'insiste plus. */
  function scAjouteCadeau(p,c){
    scBusy=true;
    return json('/cart/add.js',{method:'POST',body:JSON.stringify({items:[{id:p.variante,quantity:1,properties:{_cadeau:c.cle,'Cadeau':c.etiquette}}]})})
      .then(function(){return json('/cart.js');})
      .then(function(x){
        var g=x.items.filter(estCadeau).filter(function(l){return l.handle===c.handle;})[0];
        if(g&&!cadeauOk(x,g)){scCadeauKo=true;return json('/cart/change.js',{method:'POST',body:JSON.stringify({id:g.key,quantity:0})});}
        return x;
      })
      .finally(function(){scBusy=false;});
  }

  function render(cart){
    document.querySelectorAll('.header__cart-count').forEach(function(n){n.textContent=cart.item_count;n.hidden=!cart.item_count;});
    var body=overlay.querySelector('[data-sc-liste]'),fin=overlay.querySelector('[data-sc-fin]'),foot=overlay.querySelector('[data-sc-foot1]');
    if(!cart.items.length){
      overlay.querySelector('.sc__title').textContent='Votre panier';
      body.innerHTML='<div class="sc__empty"><p>Votre panier est vide.</p><p>Vous ne savez pas par où commencer ? Le Kit 28 jours a tout ce qu’il faut, livraison offerte.</p><a class="sc__cta" href="'+root+'/products/pack-challenge-28-jours">Voir le Kit 28 jours · 34,90 €</a><p><a href="'+root+'/collections/all">Tous les produits</a></p></div>';
      foot.innerHTML='';fin.innerHTML='';rafraichirExpress(null);
      return;
    }
    overlay.querySelector('.sc__title').textContent='Votre panier ('+cart.item_count+' article'+(cart.item_count>1?'s':'')+')';
    var offres=scSuggestions(cart);
    var groupes=scGroupes(cart);
    var economie=cart.original_total_price>cart.total_price?'<s>'+money(cart.original_total_price)+'</s>':'';
    var offrablePays=scPortOffrable(),relais=scPrixRelais();
    var offerte=offrablePays&&(portAbo(cart)||cart.total_price>=SC_SEUIL_PORT);
    var port=(offerte||relais===null)?0:relais,total=cart.total_price+port;
    body.innerHTML=scProgression(cart)
      +groupes.filter(function(i){return !estCadeau(i);}).concat(groupes.filter(estCadeau)).map(scLigne).join('')
      +(offres?'<div class="sc__offres">'+offres+'</div>':'')
      +'<div class="sc__recap">'
        +'<div class="sc__sub sc__sub--ligne"><span>Sous-total</span><span>'+money(cart.total_price)+economie+'</span></div>'
        +(relais===null
          ?'<div class="sc__sub sc__sub--ligne"><span>Livraison</span><span>calculée au paiement</span></div>'
          :'<div class="sc__sub sc__sub--ligne"><span>Livraison en point relais</span><span>'+(offerte?'Offerte':money(relais))+'</span></div>')
        +'<div class="sc__sub"><span>Total TTC</span><span class="sc__sub-amount">'+money(total)+'</span></div>'
      +'</div>';
    fin.innerHTML='<p class="sc__trust">Expédié de Nice sous 48 h ouvrées · 60 jours pour essayer, vous gardez les produits · Paiement sécurisé</p>'
      +logos()+scCode(cart);
    foot.innerHTML='<button class="sc__cta" type="button" data-sc-checkout><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Passer ma commande · '+money(total)+'</button>';
    if(overlay.classList.contains('is-open'))rafraichirExpress(cart);
  }

  /* Le catalogue de suggestions est lu une fois, au premier affichage. */
  function scChargeCatalogue(){
    if(scCatalogue)return Promise.resolve(scCatalogue);
    /* Le cadeau n'est pas une suggestion : on le charge quand meme, sinon
       `produit()` ne le trouve pas et il ne peut pas etre ajoute au panier. */
    return Promise.all(SC_SUGGESTIONS.concat([H.bienvenue,H.appoint]).map(function(h){
      return fetch(root+'/products/'+h+'.js').then(function(r){return r.ok?r.json():null;}).catch(function(){return null;});
    })).then(function(liste){
      scCatalogue=liste.filter(Boolean).map(function(p){
        var v=(p.variants||[]).filter(function(x){return x.available;})[0]||(p.variants||[])[0];
        var g=(p.selling_plan_groups||[])[0],pl=g&&(g.selling_plans||[])[0];
        return v?{handle:p.handle,titre:p.title,prix:v.price,variante:v.id,image:p.featured_image||(p.images||[])[0]||'',plan:pl?pl.id:null,planPrix:pl?(pl.price_adjustments||[]).map(function(a){return a.value_type==='price'?a.value:null;}):[]}:null;
      }).filter(Boolean);
      return scCatalogue;
    });
  }
  function loadCart(show){return json('/cart.js').then(function(c){cartCurrency=c.currency||cartCurrency;lastCart=c;render(c);if(show)open();scChargeCatalogue().then(function(){return scCadeau(lastCart);}).then(function(c2){if(c2&&c2.items)lastCart=c2;else return json('/cart.js').then(function(c3){lastCart=c3;});}).then(function(){if(lastCart)render(lastCart);}).catch(function(){});return c;});}
  overlay.addEventListener('click',function(e){
    var rm=e.target.closest('[data-sc-retirer]');
    if(rm){var up={};rm.dataset.scRetirer.split(',').forEach(function(k){if(k)up[k]=0;});rm.disabled=true;json('/cart/update.js',{method:'POST',body:JSON.stringify({updates:up})}).then(function(){return loadCart(false);}).catch(function(){rm.disabled=false;});return;}
    var q=e.target.closest('[data-key][data-qty]');
    if(q){json('/cart/change.js',{method:'POST',body:JSON.stringify({id:q.dataset.key,quantity:Number(q.dataset.qty)})}).then(function(){return loadCart(false);}).catch(function(err){alert(err.message);});return;}
    var rt=e.target.closest('[data-sc-rituel]');
    if(rt){var kp=produit(H.kit);if(!kp||!kp.plan)return;rt.disabled=true;json('/cart/change.js',{method:'POST',body:JSON.stringify({id:rt.dataset.scRituel,quantity:1,selling_plan:kp.plan})}).then(function(){return loadCart(false);}).catch(function(){rt.disabled=false;});return;}
    var a=e.target.closest('[data-sc-ajout]');
    if(a){a.disabled=true;json('/cart/add.js',{method:'POST',body:JSON.stringify({items:[{id:Number(a.dataset.scAjout),quantity:1}]})}).then(function(res){dlPush('shopify_add_to_cart',res&&res.items?res.items:[]);return loadCart(false);}).catch(function(err){alert(err.message);a.disabled=false;});return;}
    var g=e.target.closest('[data-sc-glisse]');
    if(g){var piste=overlay.querySelector('.sc__gift-track');if(piste)piste.scrollBy({left:Number(g.dataset.scGlisse)*piste.clientWidth*0.6,behavior:'smooth'});return;}
    if(e.target.closest('[data-sc-code-ouvrir]')){scCodeOuvert=true;if(lastCart)render(lastCart);var fc=document.getElementById('sc-code');if(fc)fc.focus();return;}
    if(e.target.closest('[data-sc-checkout]')){e.preventDefault();goCheckout();}
  });
  overlay.addEventListener('submit',function(e){
    var f=e.target.closest('[data-sc-code]');if(!f)return;e.preventDefault();
    var code=(f.querySelector('input').value||'').trim();if(!code)return;
    var deja=(lastCart&&lastCart.discount_codes||[]).map(function(c){return c.code;}).filter(function(c){return c.toUpperCase()!==code.toUpperCase();});
    json('/cart/update.js',{method:'POST',body:JSON.stringify({discount:deja.concat([code]).join(',')})}).then(function(){return loadCart(false);}).catch(function(){});
  });
  document.addEventListener('click',function(e){var cart=e.target.closest('.header__cart-trigger');if(cart){e.preventDefault();loadCart(true);}},true);
  function variants(scope){try{return JSON.parse(scope.querySelector('[data-product-variants]').textContent);}catch(e){return[];}}
  function selectedQty(scope){var n=scope.querySelector('.pdp__flavour.is-selected');return Math.max(1,Number(n&&n.dataset.quantity||1));}
  function selectedSubscription(scope){var n=scope.querySelector('.pdp__cure.is-selected');return !!(n&&n.dataset.subscription==='true');}
  function sellingPlans(scope){try{return JSON.parse(scope.querySelector('[data-selling-plans]').textContent)||[];}catch(e){return[];}}
  /* v29 (12/10, Xebec) : chaque groupe d'abonnement n'a qu'un rythme (6 semaines). On prend toujours
     le premier plan (prix à l'unité : Kit 29,90 puis 24,90, Dentifrice -15 %, Siwak Addict 17 €,
     NanoBrosse 6,70 €, Recharge 24,90 €). Les prix de lot en abonnement (2 ou 3 unités, -15 % sur le
     prix du lot en achat unique) viennent des remises automatiques Shopify « Abonnement … ». */
  function planFor(scope,qty){
    var list=sellingPlans(scope);if(!list.length)return scope.dataset.sellingPlanId||null;
    return list[0].id;
  }
  function itemsFor(scope){
    var handle=scope.dataset.shopifyProductHandle,qty=selectedQty(scope),sub=selectedSubscription(scope),list=variants(scope),id=Number(scope.dataset.defaultVariantId),items=[];
    /* Carte qui vend un autre produit (pack Kit + Recharge) : sa variante est portée par la carte. */
    var carte=scope.querySelector('.pdp__cure.is-selected[data-variant-id]');
    if(carte){items.push({id:Number(carte.dataset.variantId),quantity:1});return items;}
    /* Masterclass CRO 6.4 : le dentifrice se vend au tube (variante 1 tube × quantité) ; les paliers
       2 tubes 26,90 € et 3 tubes 37,90 € sont des remises automatiques Shopify. v29 : l'abonnement
       envoie le lot choisi au 1er envoi ; ensuite l'app renouvelle 1 tube (v31). */
    if(handle==='dentifrice-au-siwak'){id=Number((list[0]||{}).id||id);}
    var fmt=scope.querySelector('.pdp__flavour.is-selected[data-variant-id]');
    if(fmt&&!sub){items.push({id:Number(fmt.dataset.variantId),quantity:1});return items;}
    var line={id:id,quantity:qty};
    if(sub){
      var plan=planFor(scope,qty);
      if(!plan)throw new Error('L’abonnement est momentanément indisponible. Choisissez l’achat unique ou réessayez dans quelques instants.');
      line.selling_plan=Number(plan);
    }
    items.push(line);return items;
  }
  document.addEventListener('click',function(e){
    var button=e.target.closest('.pdp__atc');if(!button)return;
    var scope=button.closest('[data-shopify-product-handle]');if(!scope)return;
    e.preventDefault();e.stopImmediatePropagation();button.classList.add('is-loading');button.setAttribute('aria-busy','true');
    var items;
    try{items=itemsFor(scope);}catch(err){alert(err.message);button.classList.remove('is-loading');button.removeAttribute('aria-busy');return;}
    json('/cart/add.js',{method:'POST',body:JSON.stringify({items:items})}).then(function(res){dlPush('shopify_add_to_cart',res&&res.items?res.items:[]);return loadCart(true);}).catch(function(err){
      /* Message sous le bouton plutôt qu'une alerte (ex. pack pas encore en vente). */
      var note=scope.querySelector('[data-atc-erreur]');
      if(!note){note=document.createElement('p');note.setAttribute('data-atc-erreur','');note.setAttribute('role','alert');note.style.cssText='margin:0 0 12px;text-align:center;font-size:13px;line-height:19px;color:#B42318';button.insertAdjacentElement('afterend',note);}
      note.textContent=scope.querySelector('.pdp__cure.is-selected[data-variant-id]')?'Ce pack sera disponible au lancement de l’offre. Choisissez le Kit seul en attendant.':'Ajout impossible pour le moment. Réessayez dans un instant ou écrivez-nous sur WhatsApp.';
    }).finally(function(){button.classList.remove('is-loading');button.removeAttribute('aria-busy');});
  },true);
  var quick={kit:48582338609484,recharge:58813899112780,dentifrice:47827029721420,'siwak-addict':47834300973388,nanobrosse:52605078896972};
  document.addEventListener('click',function(e){var b=e.target.closest('[data-quick-add]');if(!b)return;var id=quick[b.dataset.quickAdd];if(!id)return;e.preventDefault();e.stopImmediatePropagation();json('/cart/add.js',{method:'POST',body:JSON.stringify({items:[{id:id,quantity:1}]})}).then(function(res){dlPush('shopify_add_to_cart',res&&res.items?res.items:[]);return loadCart(true);}).catch(function(err){alert(err.message);});},true);
  document.addEventListener('click',function(e){if(e.target.closest('.shopify-cart-page__button[name="checkout"]'))dlPush('shopify_begin_checkout',cartItems());},true);
  loadCart(false).catch(function(){});
})();
